import { render, staticRenderFns } from "./TransferTermsModal.vue?vue&type=template&id=37667f9c"
import script from "./TransferTermsModal.vue?vue&type=script&lang=js"
export * from "./TransferTermsModal.vue?vue&type=script&lang=js"
import style0 from "./TransferTermsModal.vue?vue&type=style&index=0&id=37667f9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports